import { generateUniqueKeywords } from "../../../js/helpers/keywordHelpers";

export function validateJobContactDetails(values) {
  const isContactMethodComplete =
    values.contactEmail !== "" ||
    values.phoneNumber !== "" ||
    values.contactWebsiteUrl.url !== "";

  return (
    // values.contactName !== "" &&
    isContactMethodComplete &&
    values.location.hasOwnProperty("areaLevelOne") &&
    values.location.areaLevelOne !== ""
  );
}

export function isDescriptionCountValid(description) {
  const descriptionWordCount = generateUniqueKeywords(
    description.replace(/<[^>]+>/g, " ")
  ).length;
  return descriptionWordCount >= 20 && descriptionWordCount <= 900;
}
